// React imports.
import React, { Component, } from "react";

// App imports.
import { createState, AppPagesEnum } from "../state";
import DataCategories from "./DataCategories";
import DataSubCategories from "./DataSubCategories";
import DataFields from "./DataFields";
import SelectedDataFields from "./SelectedDataFields";
import Grantees from "./Grantees";
import FiscalYears from "./FiscalYears";
import GraphTypes from "./GraphTypes";
import ReportDataTable from "./ReportDataTable";
import ChartParent from "./ChartParent";

class BaseLayout extends Component {
  state = createState(this);

  /**
   * Render().
   */
  render() {
    return (
      <div>
        <div className={"row noPrint"}>
          <div className={"col-md-12 title-bar"}>
            <div className={"d-flex bd-highlight"}>
              <div className={"mr-auto px-2 bd-highlight"}>
                <h2>Custom Reports</h2>
              </div>
              <div className={"p-2 bd-highlight"}>
                <a href="/data_warehouse/doc/LIHEAP_PM_Glossary.pdf" >LIHEAP Glossary</a>
              </div>
              <div className={"p-2 bd-highlight"}>
                <a href="/data-warehouse-help" >Reports Help</a>
              </div>
              <div className={"p-2 bd-highlight"}>
                <a href="/data-feedback">Site Feedback</a>
              </div>
            </div>
          </div>
        </div>
        {/*----------------------------
        * Display error message
        * ----------------------------*/}
        {this.state.ShowSpinner == true
          && <img src="/data_warehouse/images/spinner-small.gif" alt="Image to show that page is loading" className="spinner" style={{ padding: 20, }} />
        }
        {(this.state.ErrorMessage !== '')
          && <span className="errorMessageText"><br /><br />{this.state.ErrorMessage}<br /><br /></span>
        }
        {/*----------------------------*/}

        {(this.state.CurrentPage === AppPagesEnum.CreateReport)
          &&
          <div className="noPrint">
            <fieldset>
              <legend>Step 1: Select the data fields you want to use:</legend>
              <br />
              <div className="container">
                <div className="row">
                  <div className="col-sm">
                    <strong>Select the kind of data you want:</strong>
                    <DataCategories fieldCategories={this.state.getFieldCategories()}
                      selectedCategoryId={this.state.SelectedCategoryId}
                      setSelectedCategoryId={this.state.setSelectedCategoryId}></DataCategories>
                  </div>
                  <div className="col-sm">
                    <strong>Select a data category:</strong>
                    <DataSubCategories fieldSubCategories={this.state.SelectedFieldSubcategories}
                      selectedSubCategoryId={this.state.SelectedSubCategoryId}
                      setSelectedSubCategoryId={this.state.setSelectedSubCategoryId}></DataSubCategories>
                  </div>
                  <div className="col-sm">

                    <strong>Select data fields (hover for help):</strong>
                    <DataFields fields={this.state.Fields}
                      selectedCategoryId={this.state.SelectedSubCategoryId}
                      toggleFieldSelected={this.state.toggleFieldSelected}></DataFields>
                  </div>
                </div>
              </div>
            </fieldset>
            <br />
            <fieldset>
              <legend>Step 2: Filter your data for analysis::</legend>
              <br />
              <div className="container">
                <div className="row">
                  <div className="col-sm">
                    <strong>Data fields selected:</strong>
                    &nbsp;&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); this.state.deselectAllFields(e); }} className="font-weight-bold">Clear all</a>
                    <SelectedDataFields fields={this.state.Fields}
                      toggleFieldSelected={this.state.toggleFieldSelected}></SelectedDataFields>
                  </div>
                  <div className="col-sm">
                    <strong>Select grantees:</strong>
                    &nbsp;&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); this.state.setSelectionAllGrantees(true); }} className="font-weight-bold">Select all</a>
                    &nbsp;&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); this.state.setSelectionAllGrantees(false); }} className="font-weight-bold">Clear all</a>
                    <Grantees allGranteesSelected={this.state.AllGranteesSelected}
                      grantees={this.state.Grantees.slice(1)}
                      toggleGranteeSelected={this.state.toggleGranteeSelected}
                      toggleAllGranteesSelected={this.state.toggleAllGranteesSelected}></Grantees>
                  </div>
                  <div className="col-sm">
                    <strong>Select fiscal years:</strong>
                    &nbsp;&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); this.state.setSelectionAllFiscalYears(true); }} className="font-weight-bold">Select all</a>
                    &nbsp;&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); this.state.setSelectionAllFiscalYears(false); }} className="font-weight-bold">Clear all</a>
                    <FiscalYears fiscalYears={this.state.FiscalYears}
                      toggleFiscalYearSelected={this.state.toggleFiscalYearSelected}></FiscalYears>
                    *Data for years marked with an asterisk are preliminary pending final data validation.
                  </div>
                </div>
              </div>
            </fieldset>
            <br />
            <fieldset>
              <legend>Step 2: Filter your data for analysis:</legend>
              <br />
              <div className="container">
                <div className="row">
                  <div className="col-sm">
                    <strong>Select how to display your data:</strong>
                    <GraphTypes graphTypes={this.state.GraphTypes}
                      selectGraphType={this.state.selectGraphType}></GraphTypes>
                  </div>
                  <div className="col-sm">
                    <strong>Add a title, subtitle, and description:</strong>
                    &nbsp;
                    <a href="#" id="btnClearTitle">Clear</a>
                    <label htmlFor="txtTitle" className="screenReader" >Title</label>
                    <input placeholder="Report Title"
                      type="text"
                      id="txtTitle"
                      className="form-control"
                      value={this.state.ReportTitle}
                      onChange={this.state.setReportTitle}
                    />
                    <label htmlFor="txtSubTitle" className="screenReader">Sub-title</label>
                    <input placeholder="Report Sub-title"
                      type="text"
                      id="txtSubTitle"
                      className="form-control"
                      value={this.state.ReportSubTitle}
                      onChange={this.state.setReportSubTitle} />
                    <label htmlFor="txtDescription" className="screenReader">Description</label>
                    <input placeholder="Report Description"
                      type="text"
                      id="txtDescription"
                      className="form-control"
                      value={this.state.ReportDescription}
                      onChange={this.state.setReportDescription} />

                    <button id="btnGetData"
                      className="dataButton"
                      disabled={this.state.displayReportDisabled()}
                      onClick={this.state.displayReport}
                    >
                      Create Your Data Report
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        }
        {(this.state.CurrentPage === AppPagesEnum.DisplayReport)
          &&
          <div >
            <div className="noPrint">
              <a href="#" onClick={() => this.state.customizeReport()}>Customize report</a>
              &nbsp;|&nbsp;
              <a href="/datawarehouse/" >Back to report selection</a>
            </div>
            <br />

            {(this.state.GraphTypes.bar.graphTypeSelected
              || this.state.GraphTypes.map.graphTypeSelected
              || this.state.GraphTypes.multiBar.graphTypeSelected
              || this.state.GraphTypes.stackedBar.graphTypeSelected
              || this.state.GraphTypes.stackedBarPercent.graphTypeSelected
              || this.state.GraphTypes.combo.graphTypeSelected
              || this.state.GraphTypes.line.graphTypeSelected
              || this.state.GraphTypes.pie.graphTypeSelected)
              &&
              <div id ="chartContainer">
              <ChartParent graphTypes={this.state.GraphTypes}
                fiscalYears={this.state.FiscalYears.filter(f => f.fiscalYearSelected)}
                grantees={this.state.Grantees.filter(f => f.granteeSelected)}
                title={this.state.ReportTitle}
                subTitle={this.state.ReportSubTitle}
                reportData={this.state.ReportData.reportData}
                selectedFields={this.state.Fields.filter(f => f.tableFieldSelected)}
              ></ChartParent>
              </div>
            }

            <div dangerouslySetInnerHTML={{ __html: this.state.ReportDescription.replace(/\.\.\.\./g, '<br/>') }} />
            <br />

            {this.state.selectedYearsIncludesIncomplete()
              &&
              <div>*Data for years marked with an asterisk are preliminary pending final data validation.</div>
            }
            {this.state.ReportData.includesZeroValues
              &&
              <div className="centeredTextDiv">
                NOTE: One or more of the data elements selected has a value of zero (0) for at least one of the grantees
                and/or years selected.  Zero values are reported by grantees and are valid.  For data elements that indicate
                the number of assisted households, a zero value indicates that a grantee reported no households received the
                type of assistance in a specified fiscal year.  For data elements that indicate dollar values, a zero value
                indicates that no funds were obtained, used, or granted for that particular item in the specified fiscal year.
                To obtain more information on why a grantee has a value of 0 for a specific data element, consult the LIHEAP
                Report to Congress for the appropriate fiscal year of interest.
              </div>
            }
            {this.state.ReportData.includesNullValues
              &&
              <div className="centeredTextDiv">
                NOTE:  One or more of the data elements selected does not have data available for at least one of the grantees
                and/or years selected. &nbsp;&nbsp;Unavailable data are marked “NA” in the data table. &nbsp;Data may be unavailable because a
                data element was not collected for the specified fiscal year or the data are&nbsp;suppressed due to data quality concerns. &nbsp;&nbsp;
                To obtain more information on why a specific data element is unavailable for a grantee, consult the LIHEAP
                Report to Congress for the appropriate fiscal year of interest.
              </div>
            }
            <br />
            <a className="noPrint" href="#" onClick={() => this.state.print()}>Print report</a>
            <br />
            <ReportDataTable
              caption={this.state.ReportTitle}
              reportData={this.state.ReportData}></ReportDataTable>

          </div >
        }
      </div>
    );
  }

}
export default BaseLayout;
